import React, { Component } from "react";
import {
  FormGroup,
  Input,
  Label,
  NavLink,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { Link, withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faInfoCircle,
  faUserNinja
} from "@fortawesome/pro-solid-svg-icons";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
  CSVExport
} from "react-bootstrap-table2-toolkit";
import { deleteCustomFieldByIdAPI } from "./customFieldsAPI";
import paginationFactory from "react-bootstrap-table2-paginator";
import { toast } from "react-toastify";
import { getTemplateRegardingObjectType } from "../../../company-admin/views/claims/companyClaimsAPI";
import { getRegardingCustomFieldsAPI } from "../../../company-admin/views/custom-fields/customFieldsCompanyAPI";
import TranslatableText from "../../../../Language/TranslatableText";
import { getProjectsAPI } from "../projects/projectsAPI";
import { GlobalContext } from "../../../../contexts/global-context";
import { InlineLoading } from "../../../../components";



const { SearchBar } = Search;
const { ExportCSVButton } = CSVExport;
const NoDataIndication = () => (
  <div className="text-center">
    <span>
      <TranslatableText translationKey="no_data_available" />
    </span>
  </div>
);

class CustomFields extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationId: "",
      tableLoader: false,
      entity: "",
      organizationDropdown: [],
      regardingObjectTypeIdDropdown: [],
      customFields: [],
      columns: [
        {
          dataField: "id",
          text: "ID",
          hidden: true
        },
        {
          dataField: "name",
          text: "Field Name",
          sort: true
        },
        {
          dataField: "displayText",
          text: "Display Text",
          sort: true
        },
        {
          dataField: "dataType",
          text: "Type",
          sort: true
        },
        {
          dataField: "displayType",
          text: "Display Type",
          sort: true
        },
        {
          dataField: "actions",
          text: "Action",
          csvExport: false,
          formatter: (cell, row) => {
            return (
              <div className="actions">
                <NavLink
                  tag={Link}
                  to={`${this.props.match.path}/details/${row.id}/${row.regardingObjectTypeId}`}
                >
                  <FontAwesomeIcon icon={faInfoCircle} size="1x" />
                </NavLink>
                <NavLink
                  tag={Link}
                  to={`${this.props.match.path}/update/${row.id}/${row.regardingObjectTypeId}/${row.organizationId}`}
                >
                  <FontAwesomeIcon icon={faEdit} size="1x" />
                </NavLink>
                <NavLink onClick={e => this.openDeleteModal(row.id, e)}>
                  <FontAwesomeIcon
                    style={{ color: "#d84a4a" }}
                    icon={faTrash}
                    size="1x"
                  />
                </NavLink>
              </div>
            );
          }
        }
      ],
      deleteModal: false,
      customFieldId: null
    };
  }
  componentDidMount() {
    getProjectsAPI()
      .then(res => {
        this.setState({ organizationDropdown: Array.isArray(res) ? res : [] });
      })
      .catch(error => {
        toast.error(this.context.languages["api_error"], {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 3000
        });
      });
  }

  populateEntities = event => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (value === "") {
      this.setState({
        regardingObjectTypeIdDropdown: []
      });
    } else {
      getTemplateRegardingObjectType()
        .then(res => {
          this.setState({
            regardingObjectTypeIdDropdown: Array.isArray(res) ? res : []
          });
        })
        .catch(error => {
          toast.error(this.context.languages["api_error"], {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 3000
          });
        });
    }

    this.setState({
      [name]: value,
      entity: "",
      customFields: []
    });
  };

  toggleDeletePopup = () => {
    this.setState(
      prevState => ({
        deleteModal: !prevState.deleteModal
      }),
      () => {
        if (this.state.deleteModal === false) {
          this.setState({
            customFieldId: null
          });
          console.log("After Modal Dismissal", this.state.deleteModal);
        }
      }
    );
  };

  openDeleteModal = id => {
    this.setState({
      deleteModal: true,
      customFieldId: id
    });
  };

  populateCustomFields = (regardingObjectId, organizationId) => {
    this.setState({ tableLoader: true, customFields: [] });
    getRegardingCustomFieldsAPI(regardingObjectId, organizationId)
      .then(res => {
        if (!Array.isArray(res)) {
          console.log("debug: ", res);
          return;
        }
        this.setState({ customFields: res, tableLoader: false });
      })
      .catch(error => {
        toast.error(this.context.languages["api_error"], {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 3000
        });
        this.setState({ tableLoader: false });
      });
  };

  goBack = () => {
    this.props.history.goBack();
  };

  deleteCustomField = id => {
    deleteCustomFieldByIdAPI(id)
      .then(res => {
        this.populateCustomFields(this.state.entity, this.state.organizationId);
        this.setState({
          deleteModal: false,
          customFieldId: null
        });
      })
      .catch(error => {
        toast.error(this.context.languages["api_error"], {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 3000
        });
        this.setState({
          deleteModal: false,
          customFieldId: null
        });
      });
  };

  handleChange = event => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState(
      {
        [name]: value
      },
      () => {
        this.populateCustomFields(value, this.state.organizationId);
      }
    );
  };

  render() {
    let { customFields, columns, tableLoader } = this.state;
    return (
      <div className="admin-custom-fields-view">
        <h1>
          <TranslatableText translationKey="custom_fields" />
        </h1>
        <hr />
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="organizationId">
                <TranslatableText translationKey="custom_fields.select_organisation" />
              </Label>
              <Input
                type="select"
                name="organizationId"
                id="organizationId"
                value={this.state.organizationId}
                onChange={this.populateEntities}
                disabled={
                  this.props.match.params.id !== undefined ? true : null
                }
              >
                <option value="">-- Vælg --</option>
                {this.state.organizationDropdown.map((e, key) => {
                  return (
                    <option key={e.id} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </Input>
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="entity">Select an Entity</Label>
              <Input
                type="select"
                name="entity"
                id="entity"
                value={this.state.entity}
                onChange={this.handleChange}
              >
                <option value="">-- Vælg --</option>
                {this.state.regardingObjectTypeIdDropdown.map((e, key) => {
                  return (
                    <option key={e.id} value={e.id}>
                      {e.name}
                    </option>
                  );
                })}
              </Input>
            </FormGroup>
          </Col>
        </Row>
        <div className="table-container">
          <ToolkitProvider
            keyField="id"
            data={customFields}
            columns={columns}
            search
            exportCSV={{
              fileName: "data.csv",
              separator: this.context.user.language === 'dk' ? ';' : ',',
              ignoreHeader: false,
              noAutoBOM: false
            }}
          >
            {props => (
              <div>
                <div className="flex space-between">
                  <div>
                    <SearchBar {...props.searchProps} />
                  </div>
                  <div>
                    <div className="flex space-between">
                      {this.context.userRoles.find(r =>
                        r.includes("Developer")
                      ) !== undefined && this.state.entity !== "" ? (
                        <ExportCSVButton
                          className="export-btn"
                          {...props.csvProps}
                        >
                          <FontAwesomeIcon icon={faUserNinja} size="1x" />&nbsp;CSV</ExportCSVButton>
                      ) : (
                        <></>
                      )}
                      <div>
                        {this.state.entity !== "" ? (
                          <NavLink
                            className="button-primary"
                            tag={Link}
                            to={`${this.props.match.path}/create/${this.state.entity}/${this.state.organizationId}`}
                          >
                            <TranslatableText translationKey="create" />
                          </NavLink>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <BootstrapTable
                  noDataIndication={() =>
                    tableLoader ? (
                      <InlineLoading />
                    ) : (
                      <NoDataIndication />
                    )
                  }
                  {...props.baseProps}
                  pagination={paginationFactory()}
                />
              </div>
            )}
          </ToolkitProvider>
        </div>
        <Row>
          <Col md={12}>
            <Button onClick={this.goBack}>
              <TranslatableText translationKey="back" />
            </Button>
          </Col>
        </Row>
        <Modal
          isOpen={this.state.deleteModal}
          toggle={this.toggleDeletePopup}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggleDeletePopup}>
            <TranslatableText translationKey="confirm_delete" />?
          </ModalHeader>
          <ModalBody>
            <Row form>
              <Col md={12}>
                <p>
                  {" "}
                  <TranslatableText translationKey="custom_fields.confirm_delete_description" />
                </p>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              outline
              className="redOutline"
              onClick={e => this.deleteCustomField(this.state.customFieldId, e)}
            >
              <TranslatableText translationKey="delete" />
            </Button>{" "}
            <Button outline onClick={this.toggleDeletePopup}>
              <TranslatableText translationKey="cancel" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  languages: state.languageResources.language_resources,
  user: state.organizations,
  roles: state.userRoles,
  loading: state.organizations.loading,
  error: state.organizations.error
});

export default withRouter(CustomFields);
CustomFields.contextType = GlobalContext;